function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#FCB243"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.326 22.3l-1.145-4.92L23 14.07l-5.034-.431L16 9l-1.966 4.639L9 14.07l3.819 3.309-1.145 4.92L16 19.69l4.326 2.61z",
  fill: "#fff"
});

var SvgIconStarActive = function SvgIconStarActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTYiIGZpbGw9IiNGQ0IyNDMiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMC4zMjYgMjIuM0wxOS4xODE1IDE3LjM3OTdMMjMgMTQuMDcwOEwxNy45NjYzIDEzLjYzODlMMTYgOUwxNC4wMzM3IDEzLjYzODlMOSAxNC4wNzA4TDEyLjgxODUgMTcuMzc5N0wxMS42NzQgMjIuM0wxNiAxOS42OTA0TDIwLjMyNiAyMi4zWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgIconStarActive as ReactComponent };